import { Moment } from "moment";
import { useState, useEffect } from "react";
import { Payload } from "./Payload";
import { GamePricingDetails } from "./Models";

export const useGamePricingDetails = (loggedIn: boolean | undefined, date: Moment) => {
  const [result, setResult] = useState<Payload<GamePricingDetails[]>>({
    status: "init",
  });

  const dateArg = `${date.year()}-${date.month() + 1}-${date.date()}`;

  useEffect(() => {
    function getDetails() {
      fetch(`/api/GamePricingDetails?date=${dateArg}`)
        .then((response) => response.json())
        .then((response) => setResult({ status: "loaded", payload: response }))
        .catch((error) => {
          console.log(error.toString());
          setResult({ status: "error", error });
        });
    }
    if (loggedIn === true) {
      getDetails();
      const interval = setInterval(() => getDetails(), 60000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [dateArg, loggedIn]);

  return result;
};
